import { createI18n } from 'vue-i18n'
// 2026-10-18：使用完整中文键集合生成英文和维语词典，缺失项由覆盖检查发现。
import { normalizeLanguage, setDisplayLanguage, translateMessages } from './display'
import type { UiLanguage } from './display'
import langZh from './lang/zh'
import { LANG } from '@/constants'
import { getItem } from '@/utils/storege'
const messages = {
  en: {
    msg: {
      ...translateMessages(langZh, 'en'),
      test: 'Hello world',
      login:'Login',
      accountLogin:'Account Login',
      enterUser:'Please enter username',
      enterPwd:'Please enter password',
      enterPhone:'Enter phone number',
      enterCode:'Enter verification code'
    }
  },
  ug: { msg: { ...translateMessages(langZh, 'ug'), test: 'ياخشىمۇسىز', login: 'كىرىش', accountLogin: 'ھېسابات بىلەن كىرىش', enterUser: 'ئىشلەتكۈچى نامىنى كىرگۈزۈڭ', enterPwd: 'پارولنى كىرگۈزۈڭ', enterPhone: 'يانفون نومۇرىنى كىرگۈزۈڭ', enterCode: 'دەلىللەش كودىنى كىرگۈزۈڭ' } },
  zh: {
    msg: {
      ...langZh,
      test: '你好世界',
      login:'登录',
      accountLogin:'用户登录',
      enterUser:'请输入账号',
      enterPwd:'请输入密码',
      enterPhone:'请输入手机号',
      enterCode:'请输入验证码'
    }
  }
}
// 2026-10-18：为动态译文固定中文词典结构，避免vue-i18n递归推导any导致TS2589阻断构建。
const localeMessages: Record<UiLanguage, typeof messages.zh> = messages
const getLanguage=()=> {
    // 2026-09-05：直接读取语言偏好，避免 store 循环初始化时取不到语言而默认显示英文。
    const ss = setDisplayLanguage(normalizeLanguage(getItem(LANG)))
    //console.log(ss)
    return ss
  }
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale:getLanguage(),
  fallbackLocale:'zh',
  messages: localeMessages
})
export default i18n
